import { useEffect, useState } from 'react';
import { getAlertByClients } from '../../../features/alerts/requests';
import { alertListType } from '../types';
import { useLoaderData } from 'react-router-dom';
import { authType } from '../../../features/client/types';
import useFetchUser from '../../../features/client/hooks/useFetchUser';

const useGetAlert = (): alertListType => {
  const [alertListFromApi, setAlertListFromApi] = useState<alertListType>([]);

  const authInfo = useLoaderData() as authType;
  const { isPaid, loading } = useFetchUser(authInfo.user.cognito_username);

  useEffect(() => {
    if (!isPaid) return;

    if (!loading) {
      const fetchAlerts = async () => {
        try {
          const res = await getAlertByClients();
          setAlertListFromApi(res);
        } catch (error) {
          // エラーハンドリングをここに追加することができます
        }
      };
      fetchAlerts();
    }
  }, [isPaid, loading]);

  return alertListFromApi;
};

export default useGetAlert;
